/**
 *
 * @param {Map<String, Map<String, String>>} applied
 * @param {String} parent
 * @param {String} fn
 * @param {String} current
 * @param {Boolean} isInitial
 */
const getAppliedInitials = (applied, parent, fn, current, isInitial) => {
  if (!applied) {
    return;
  }

  if (isInitial) {
    if (!applied.has(parent)) {
      applied.set(parent, new Map());
    }

    applied.get(parent)?.set(fn, current);
  } else {
    const properties = /** @type {Map<String, String>} */ (applied.get(parent));

    if (!properties) {
      return;
    }

    if (properties.has(fn)) {
      properties.delete(fn);
    }
  }
};

export default getAppliedInitials;
